import React from 'react';

const Holidays = (props) => {

    return (<div className="p-col-12 p-lg-12 holidays">
        <ul>
            {props.data && props.data.length > 0 ? (props.data || []).map((holiday, index) =>
                <li key={index}>
                    <button className="p-link">
                        <span className="name">{`${holiday.name} (${holiday.dates})`}</span>
                        <span className="email">{holiday.holidaynum} day(s)</span>
                    </button>
                </li>) : <li>
                    <button className="p-link">
                        <span>No List.</span>
                    </button>
                </li>}
        </ul>
    </div>);


}

export default Holidays;